package er.prateek.crossly.ui.screens.levelselect

/**
 * Levels-map tour. Resume is only in the list when a saved game exists, so a
 * first visit never talks about a tile that isn't on screen.
 */
enum class LevelsCoachStep {
    TIERS,
    NEXT,
    RESUME,
}

fun levelsCoachTour(
    hasResume: Boolean,
    seenLevels: Boolean,
    seenResume: Boolean,
): List<LevelsCoachStep> {
    if (!seenLevels) {
        return buildList {
            add(LevelsCoachStep.TIERS)
            add(LevelsCoachStep.NEXT)
            if (hasResume) add(LevelsCoachStep.RESUME)
        }
    }
    if (hasResume && !seenResume) return listOf(LevelsCoachStep.RESUME)
    return emptyList()
}
